export default {"src":"/_next/static/media/ic_player_icon_skz_v2.43eb3f21.svg","height":12,"width":15,"blurWidth":0,"blurHeight":0};